<div class="flex flex-col gap-2 p-4">

  <app-greeting-header />

  @if (flagService.isEnabled('guarnicaoEscala')) {
    <app-guarnicao-card />
  }

  @if (flagService.isEnabled('celotex')) {
    <app-celotex-board />
  }

  <app-stats-cards [cards]="store.statCards()" />

  <div class="bg-pmdf-surface rounded-pmdf-card shadow-pmdf-soft border border-pmdf-border-subtle p-4 flex flex-col gap-4">
    <div class="flex items-center gap-2">
      <mat-icon class="icon-base text-pmdf-primary">bolt</mat-icon>
      <h3 class="text-sm font-semibold text-pmdf-text-primary">Acesso Rápido</h3>
    </div>

    <app-launcher-grid [apps]="store.appShortcuts()" />
  </div>

  @if (store.temErro() && !store.isLoading()) {
    <div class="flex items-center justify-between bg-pmdf-surface rounded-pmdf-card shadow-pmdf-soft border border-pmdf-border-subtle px-4 py-2">
      <span class="text-xs text-pmdf-muted-55">{{ store.erro() }}</span>
      <button
        class="flex min-h-[44px] min-w-[44px] items-center justify-center rounded-pmdf-card text-pmdf-primary active:bg-pmdf-bg-muted"
        (click)="store.loadDashboard()"
      >
        <mat-icon class="icon-sm">refresh</mat-icon>
      </button>
    </div>
  }

  @if (store.asOfFormatted()) {
    <p class="text-right text-xs text-pmdf-muted-30 -mt-2">
      Atualizado às {{ store.asOfFormatted() }}
    </p>
  }

  @if (!store.isLoading() && store.skills().dimensions.length > 0) {
    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
      <app-performance-chart [data]="store.performance()" />
      <app-skills-chart [data]="store.skills()" />
    </div>
  }
</div>
